import React from 'react';
import { getLegalDocUrl } from '../utils/api';

/** Purpose: Renders legal-notice footer links. Inputs: className?. Output: React render output (JSX). */
export default function LegalFooter({ className = '' }) {
  const privacyDocUrl = getLegalDocUrl('privacy');
  const termsDocUrl = getLegalDocUrl('terms');
  const hipaaDocUrl = getLegalDocUrl('hipaa-notice');

  return (
    <footer className={`border-t border-slate-100 glass ${className}`}>
      <div className="max-w-7xl mx-auto px-6 py-4 text-[11px] text-slate-400 flex flex-wrap gap-3 items-center justify-between">
        <p className="font-medium">MedCaddy</p>
        <div className="flex flex-wrap items-center gap-4">
          <a href="/legal" className="hover:text-brand-600 transition-colors font-medium">Legal</a>
          <a href={privacyDocUrl} className="hover:text-brand-600 transition-colors">Privacy</a>
          <a href={termsDocUrl} className="hover:text-brand-600 transition-colors">Terms</a>
          <a href={hipaaDocUrl} className="hover:text-brand-600 transition-colors">HIPAA</a>
        </div>
      </div>
    </footer>
  );
}
